import "./LodgedGeneralCollateralComponent.scss";
import {LodgedCollateralTableRow} from "../../models/table/LodgedCollateralTableRow";
import {ComponentCallback} from "../../../../../types/AngularJS";
import {LodgedCollateral} from "../../models/table/LodgedCollateral";
import {LodgeAmountService} from "../../service/lodge-amount/LodgeAmountService";

export const LodgedGeneralCollateral = "lodgedGeneralCollateral";

export function lodgedGeneralCollateral() {
    return {
        templateUrl: "app/portfolio/templates/collateral/lodge/lodged-general/LodgedGeneralCollateralComponent.html",
        bindings: {
            totalValue: "<",
            totalUsed: "<",
            utilisation: "<",
            rows: "<",
            onUnlodge: "&"
        },
        controllerAs: "ctrl",
        controller: LodgedGeneralCollateralComponentController
    };
}

export class LodgedGeneralCollateralComponentController {

    public totalValue: number;
    public totalUsed: number;
    public utilisation: number;
    public rows: Array<LodgedCollateralTableRow>;
    public onUnlodge: ComponentCallback;


    /** @ngInject */
    public constructor(private lodgeAmountService: LodgeAmountService) {

    }

    public async unlodge(collateral: LodgedCollateral) {
        // const max = collateral.used!;
        // const amount = await this.lodgeAmountService.openLodgeAmount(max);
        const quantity = collateral.quantity;
        this.onUnlodge({
            code: collateral.code,
            quantity
        });
    }
}
